import { MedplumClient } from "@medplum/core";

import { LMP_CODING_QUERY, LMP_RELIABILITY_CODING_QUERY } from "../constants/lmp";

// --- Fetch -------------------------------------------------------------------

/**
 * Fetches the most recent final LMP `Observation` linked to a pregnancy `List`.
 *
 * @param medplum - Medplum client
 * @param pregnancyRecordId - FHIR `List` resource ID representing the pregnancy record
 * @returns The most recent LMP `Observation`, or `undefined` if none is found
 */
export async function fetchLastMenstrualPeriodForPregnancyRecord(
  medplum: MedplumClient,
  pregnancyRecordId: string,
) {
  const baseQuery = {
    "_has:List:item:_id": pregnancyRecordId,
    code: LMP_CODING_QUERY,
    _sort: "-_lastUpdated",
  };

  const activeLmp = await medplum.searchOne("Observation", { ...baseQuery, status: "final" });

  if (activeLmp) return activeLmp;

  return medplum.searchOne("Observation", { ...baseQuery, status: "cancelled" });
}

/**
 * Fetches the most recent final LMP reliability `Observation` linked to a pregnancy `List`.
 *
 * @param medplum - Medplum client
 * @param pregnancyRecordId - FHIR `List` resource ID representing the pregnancy record
 * @returns The most recent LMP reliability `Observation`, or `undefined` if none is found
 */
export async function fetchLMPReliabilityForPregnancyRecord(
  medplum: MedplumClient,
  pregnancyRecordId: string,
) {
  const baseQuery = {
    "_has:List:item:_id": pregnancyRecordId,
    code: LMP_RELIABILITY_CODING_QUERY,
    _sort: "-_lastUpdated",
  };

  const activeLmpReliability = await medplum.searchOne("Observation", {
    ...baseQuery,
    status: "final",
  });

  if (activeLmpReliability) return activeLmpReliability;

  return medplum.searchOne("Observation", { ...baseQuery, status: "cancelled" });
}
